import { Component } from 'react';

import { renderField } from '../../../../../core/utils/formik';

class SelfCleaningField extends Component {
  componentWillUnmount() {
    const { field, form } = this.props;
    const { name } = field;
    form.setFieldValue(name, '');
    form.setFieldTouched(name, true);
  }

  render() {
    return renderField(this.props);
  }
}

export default SelfCleaningField;



// WEBPACK FOOTER //
// ./src/features/test/TestForm/DeviceStateFields/states/SelfCleaningField.js